/*
================================================================================
PELICANWORK MODEL 304 DESK CONFIGURATOR
Standalone Shopify-compatible script. No React, no build step.
Include Three.js r128 CDN before this script.
================================================================================
Usage in theme.liquid (before </body>):

<div id="desk-configurator-root"></div>
<script src="https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js"></script>
<script src="{{ 'desk-configurator.js' | asset_url }}"></script>

Button on product page:
<button class="open-desk-configurator" data-handle="{{ product.handle }}">
  Customize This Desk
</button>
================================================================================
*/

(function() {
'use strict';

var SCALE = 0.01;
var INCH_TO_MM = 25.4;

// ============================================================================
// SHOPIFY CONFIG
// ============================================================================
var SHOPIFY_DESKS = {
  '55_black': { handle: 'model-304' },
  '55_white': { handle: 'model-304-solid-wood-height-adjustable-desk-55x28-walnut-white-legs' },
  '60_black': { handle: 'model-304-solid-wood-height-adjustable-desk-60x30-walnut-black-legs' },
  '60_white': { handle: 'model-304-solid-wood-height-adjustable-desk-60x30-walnut-white-legs' },
};
var SHOPIFY_SHELF = { black: '52338942476597', white: '51336673886517' };
var SHOPIFY_CABLE = { black: '52321747468597', white: '52321747435829' };

// ============================================================================
// PRICING (INR)
// ============================================================================
var PRICE_PER_SQ_IN = 19.23;
var PRICE_BASE = 45286;
var PRICE_MARKUP = 1.48;
var PRICE_GROMMET = 1500;
var PRICE_SHELF = 6900;
var PRICE_SHELF_REG = 12900;
var PRICE_CABLE = 6499;
var PRICE_CABLE_REG = 8800;

function calcPrice(len, wid, nGrommets, hasCable, hasShelf) {
  var area = len * wid;
  var sale = Math.round((PRICE_BASE + area * PRICE_PER_SQ_IN) / 100) * 100;
  var reg = Math.round((sale * PRICE_MARKUP) / 100) * 100;
  sale += nGrommets * PRICE_GROMMET;
  reg += nGrommets * PRICE_GROMMET;
  if (hasCable) { sale += PRICE_CABLE; reg += PRICE_CABLE_REG; }
  if (hasShelf) { sale += PRICE_SHELF; reg += PRICE_SHELF_REG; }
  return { sale: sale, regular: reg };
}

function formatINR(n) {
  var s = n.toString();
  if (s.length <= 3) return s;
  var last3 = s.slice(-3);
  var rest = s.slice(0, -3);
  return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
}

// ============================================================================
// SHOPIFY CART
// ============================================================================
// IMPORTANT: Replace this URL with your Cloudflare Worker URL from Step 2
var WORKER_URL = 'https://desk-configurator.late-disk-466e.workers.dev';

function proceedToCheckout(state, panelContainer, overlay) {
  var price = calcPrice(state.length, state.width, state.grommets.length, state.addCableTray, state.addDeskShelf);
  var deskOnlyPrice = calcPrice(state.length, state.width, state.grommets.length, false, false);

  var grommetsText = state.grommets.length > 0 ? state.grommets.map(function(g, i) {
    return '#' + (i+1) + ': ' + g.fromRight + '" from right, ' + g.fromRear + '" from rear';
  }).join(' | ') : 'None';

  var body = {
    length: state.length,
    width: state.width,
    legColor: state.legColor.charAt(0).toUpperCase() + state.legColor.slice(1),
    grommets: grommetsText,
    deskPrice: deskOnlyPrice.sale * 100,
  };

  if (state.addDeskShelf) body.shelfVariantId = SHOPIFY_SHELF[state.legColor];
  if (state.addCableTray) body.cableVariantId = SHOPIFY_CABLE[state.legColor];

  // Show loading state in panel
  panelContainer.innerHTML = '';
  var loadingPanel = document.createElement('div');
  loadingPanel.style.cssText = 'padding:40px 24px;display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;text-align:center;';
  loadingPanel.innerHTML = '<div style="width:40px;height:40px;border:3px solid #e0e0e0;border-top:3px solid #1a1a1a;border-radius:50%;animation:dcfg-spin 0.8s linear infinite;margin-bottom:20px;"></div><p style="font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 6px 0;">Creating your custom order...</p><p style="font-size:13px;color:#999;margin:0;">This takes just a moment</p>';
  var spinStyle = document.createElement('style');
  spinStyle.textContent = '@keyframes dcfg-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}';
  loadingPanel.appendChild(spinStyle);
  panelContainer.appendChild(loadingPanel);

  fetch(WORKER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.success && data.checkout_url) {
        showConfirmation(state, price, data.checkout_url, panelContainer, overlay);
      } else {
        showError(panelContainer, state, overlay);
        console.error('Draft order error:', data);
      }
    })
    .catch(function(e) {
      showError(panelContainer, state, overlay);
      console.error('Worker error:', e);
    });
}

function showConfirmation(state, price, checkoutUrl, panelContainer, overlay) {
  panelContainer.innerHTML = '';
  var panel = document.createElement('div');
  panel.style.cssText = 'padding:30px 24px;display:flex;flex-direction:column;flex:1;';

  // Success icon + title
  var header = document.createElement('div');
  header.style.cssText = 'text-align:center;margin-bottom:28px;';
  header.innerHTML = '<div style="width:56px;height:56px;border-radius:50%;background:#f0faf0;display:flex;align-items:center;justify-content:center;margin:0 auto 16px;"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#22c55e" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div><h2 style="font-size:20px;font-weight:700;color:#1a1a1a;margin:0 0 4px 0;font-family:inherit;">Your desk is ready!</h2><p style="font-size:13px;color:#888;margin:0;font-family:inherit;">Here\'s a summary of your custom configuration</p>';
  panel.appendChild(header);

  // Configuration summary
  var summary = document.createElement('div');
  summary.style.cssText = 'background:#f9f9f9;border-radius:12px;padding:20px;margin-bottom:24px;';

  var items = [
    { label: 'Model', value: 'Custom Model 304 Desk' },
    { label: 'Size', value: state.length + '" × ' + state.width + '"' },
    { label: 'Leg Color', value: state.legColor.charAt(0).toUpperCase() + state.legColor.slice(1) },
    { label: 'Grommets', value: state.grommets.length > 0 ? state.grommets.length + ' grommet' + (state.grommets.length > 1 ? 's' : '') : 'None' },
  ];
  if (state.addDeskShelf) items.push({ label: 'Add-on', value: 'Monitor Desk Shelf' });
  if (state.addCableTray) items.push({ label: 'Add-on', value: 'Cable Organizer Tray' });

  items.forEach(function(item) {
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid #eee;font-family:inherit;';
    row.innerHTML = '<span style="font-size:13px;color:#888;">' + item.label + '</span><span style="font-size:13px;font-weight:600;color:#1a1a1a;">' + item.value + '</span>';
    summary.appendChild(row);
  });

  // Price row (no border)
  var priceRow = document.createElement('div');
  priceRow.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;padding:14px 0 0 0;font-family:inherit;';
  priceRow.innerHTML = '<span style="font-size:15px;font-weight:600;color:#1a1a1a;">Total</span><div><span style="font-size:20px;font-weight:700;color:#1a1a1a;">\u20b9' + formatINR(price.sale) + '</span><span style="font-size:12px;color:#999;text-decoration:line-through;margin-left:8px;">\u20b9' + formatINR(price.regular) + '</span></div>';
  summary.appendChild(priceRow);
  panel.appendChild(summary);

  // Proceed to Checkout button
  var checkoutBtn = document.createElement('button');
  checkoutBtn.innerHTML = 'Proceed to Checkout &rarr;';
  checkoutBtn.style.cssText = 'width:100%;padding:16px;background:#1a1a1a;color:#fff;border:none;border-radius:10px;font-size:16px;font-weight:600;cursor:pointer;font-family:inherit;margin-bottom:12px;transition:background 0.2s;';
  checkoutBtn.addEventListener('click', function() { window.location.href = checkoutUrl; });
  checkoutBtn.addEventListener('mouseenter', function() { this.style.background = '#333'; });
  checkoutBtn.addEventListener('mouseleave', function() { this.style.background = '#1a1a1a'; });
  panel.appendChild(checkoutBtn);

  // Continue Shopping button
  var continueBtn = document.createElement('button');
  continueBtn.textContent = 'Continue Shopping';
  continueBtn.style.cssText = 'width:100%;padding:14px;background:transparent;color:#1a1a1a;border:2px solid #e0e0e0;border-radius:10px;font-size:14px;font-weight:500;cursor:pointer;font-family:inherit;margin-bottom:16px;transition:all 0.2s;';
  continueBtn.addEventListener('click', function() { overlay.remove(); });
  continueBtn.addEventListener('mouseenter', function() { this.style.borderColor = '#1a1a1a'; });
  continueBtn.addEventListener('mouseleave', function() { this.style.borderColor = '#e0e0e0'; });
  panel.appendChild(continueBtn);

  // Small note
  var note = document.createElement('p');
  note.style.cssText = 'font-size:11px;color:#aaa;text-align:center;margin:0;line-height:1.4;font-family:inherit;';
  note.textContent = 'Clicking "Proceed to Checkout" will take you to our secure checkout page where you can enter your shipping and payment details.';
  panel.appendChild(note);

  panelContainer.appendChild(panel);
}

function showError(panelContainer, state, overlay) {
  panelContainer.innerHTML = '';
  var panel = document.createElement('div');
  panel.style.cssText = 'padding:40px 24px;display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;text-align:center;';
  panel.innerHTML = '<div style="width:56px;height:56px;border-radius:50%;background:#fef2f2;display:flex;align-items:center;justify-content:center;margin-bottom:16px;"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg></div><p style="font-size:16px;font-weight:600;color:#1a1a1a;margin:0 0 6px 0;">Something went wrong</p><p style="font-size:13px;color:#888;margin:0 0 24px 0;">Please try again or contact us for help.</p>';
  var retryBtn = document.createElement('button');
  retryBtn.textContent = 'Try Again';
  retryBtn.style.cssText = 'padding:12px 32px;background:#1a1a1a;color:#fff;border:none;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;font-family:inherit;';
  retryBtn.addEventListener('click', function() { proceedToCheckout(state, panelContainer, overlay); });
  panel.appendChild(retryBtn);
  panelContainer.appendChild(panel);
}

// ============================================================================
// 3D BUILDING FUNCTIONS (from technical drawings)
// ============================================================================

function buildFootBar(footLength, isControlSide, isBlack) {
  var group = new THREE.Group();
  var L = footLength, W = 75, H = 21, endOffset = 30.5;
  var leverDia = footLength === 560 ? 40 : 40.5;
  var bodyColor = isBlack ? 0x2a2a2a : 0xe8e8e8;
  var edgeColor = isBlack ? 0x555555 : 0x333333;

  var bodyGeo = new THREE.BoxGeometry(L, H, W);
  group.add(new THREE.LineSegments(new THREE.EdgesGeometry(bodyGeo), new THREE.LineBasicMaterial({ color: edgeColor })));
  group.add(new THREE.Mesh(bodyGeo, new THREE.MeshBasicMaterial({ color: bodyColor, side: THREE.DoubleSide })));

  var footPadH = 10, footPadR = leverDia / 2;
  var footPadGeo = new THREE.CylinderGeometry(footPadR, footPadR * 0.9, footPadH, 24);
  var footPadEdges = new THREE.EdgesGeometry(footPadGeo, 15);
  [-1, 1].forEach(function(side) {
    var pad = new THREE.Group();
    pad.add(new THREE.LineSegments(footPadEdges.clone(), new THREE.LineBasicMaterial({ color: edgeColor })));
    if (isBlack) pad.add(new THREE.Mesh(footPadGeo.clone(), new THREE.MeshBasicMaterial({ color: 0x1a1a1a })));
    pad.position.set(side * (L/2 - endOffset - footPadR), -(H/2 + footPadH/2), 0);
    group.add(pad);
  });
  return group;
}

function buildColumn(collapsedHeight, isBlack, inwardDir) {
  var group = new THREE.Group();
  var edgeColor = isBlack ? 0x444444 : 0x333333;
  var bodyColor = isBlack ? 0x2a2a2a : 0xe5e5e5;
  var darkColor = isBlack ? 0x222222 : 0xdadada;

  function addBox(w, h, d, color, yPos, offX) {
    var geo = new THREE.BoxGeometry(w, h, d);
    var g = new THREE.Group();
    g.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo), new THREE.LineBasicMaterial({ color: edgeColor })));
    g.add(new THREE.Mesh(geo, new THREE.MeshBasicMaterial({ color: color, side: THREE.DoubleSide })));
    g.position.set(offX || 0, yPos, 0);
    group.add(g);
  }

  var motorH = 46, middlePeek = 25, innerPeek = 25;
  var outerH = collapsedHeight - middlePeek - innerPeek - motorH;
  var y = 0;

  addBox(50, outerH, 80, isBlack ? 0x2a2a2a : 0xe8e8e8, y + outerH/2);
  y += outerH;
  addBox(52, 3, 82, isBlack ? 0x202020 : 0xdadada, y + 1.5);
  y += 3;
  addBox(46, middlePeek - 3, 74, isBlack ? 0x2e2e2e : 0xececec, y + (middlePeek-3)/2);
  y += middlePeek - 3;
  addBox(48, 3, 76, isBlack ? 0x202020 : 0xdadada, y + 1.5);
  y += 3;
  addBox(42, innerPeek - 3, 68, isBlack ? 0x323232 : 0xf0f0f0, y + (innerPeek-3)/2);
  y += innerPeek - 3;

  // Motor housing
  var motorX = 177, motorZ = 97;
  var motorOffsetX = inwardDir * (motorX - 50) / 2;
  var mGeo = new THREE.BoxGeometry(motorX, motorH, motorZ);
  var mg = new THREE.Group();
  mg.add(new THREE.LineSegments(new THREE.EdgesGeometry(mGeo), new THREE.LineBasicMaterial({ color: edgeColor })));
  mg.add(new THREE.Mesh(mGeo, new THREE.MeshBasicMaterial({ color: darkColor, side: THREE.DoubleSide })));
  mg.position.set(motorOffsetX, y + motorH/2, 0);
  group.add(mg);
  y += motorH;

  group.userData.totalHeight = y;
  return group;
}

function buildTabletop(lengthMM, widthMM, grommets) {
  var group = new THREE.Group();
  var L = lengthMM, W = widthMM, H = 25, cornerR = 20;
  var maxInset = 15, power = 2.2, steps = 20, topRound = 2, segs = 20;
  var n = (segs + 1) * 4;

  function rrPts(hw, hd, r) {
    var pts = [];
    for (var i = 0; i <= segs; i++) { var a = Math.PI + (Math.PI/2)*(i/segs); pts.push([- hw+r+r*Math.cos(a), -hd+r+r*Math.sin(a)]); }
    for (var i = 0; i <= segs; i++) { var a = 1.5*Math.PI + (Math.PI/2)*(i/segs); pts.push([hw-r+r*Math.cos(a), -hd+r+r*Math.sin(a)]); }
    for (var i = 0; i <= segs; i++) { var a = (Math.PI/2)*(i/segs); pts.push([hw-r+r*Math.cos(a), hd-r+r*Math.sin(a)]); }
    for (var i = 0; i <= segs; i++) { var a = Math.PI/2 + (Math.PI/2)*(i/segs); pts.push([-hw+r+r*Math.cos(a), hd-r+r*Math.sin(a)]); }
    return pts;
  }

  var profile = [];
  for (var i = 0; i <= steps; i++) {
    var t = i / steps;
    var mainInset = maxInset * Math.pow(1 - t, power);
    var topT = Math.max(0, (t - 0.92) / 0.08);
    var topInset = topRound * Math.pow(topT, 1.5);
    profile.push({ t: t, inset: mainInset + topInset });
  }
  profile.reverse();

  var rings = profile.map(function(p) {
    var ins = p.inset;
    return { y: p.t * H, pts: rrPts(L/2 - ins, W/2 - ins, Math.max(cornerR - ins, 4)) };
  });

  var verts = [], idx = [];
  rings.forEach(function(ring) { ring.pts.forEach(function(p) { verts.push(p[0], ring.y, p[1]); }); });

  for (var r = 0; r < rings.length - 1; r++) {
    var o1 = r * n, o2 = (r+1) * n;
    for (var i = 0; i < n; i++) {
      var nx = (i+1) % n;
      idx.push(o1+i, o1+nx, o2+nx);
      idx.push(o1+i, o2+nx, o2+i);
    }
  }
  var topC = verts.length / 3;
  verts.push(0, rings[0].y, 0);
  for (var i = 0; i < n; i++) idx.push(topC, (i+1)%n, i);
  var botOff = (rings.length-1) * n;
  var botC = verts.length / 3;
  verts.push(0, rings[rings.length-1].y, 0);
  for (var i = 0; i < n; i++) idx.push(botC, botOff+i, botOff+(i+1)%n);

  var geo = new THREE.BufferGeometry();
  geo.setAttribute('position', new THREE.Float32BufferAttribute(verts, 3));
  geo.setIndex(idx);
  geo.computeVertexNormals();

  group.add(new THREE.Mesh(geo, new THREE.MeshBasicMaterial({ color: 0xd4b896, side: THREE.DoubleSide })));
  group.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo, 40), new THREE.LineBasicMaterial({ color: 0x8a7560 })));

  var topRing = rings[0];
  var topLinePts = topRing.pts.map(function(p) { return new THREE.Vector3(p[0], topRing.y, p[1]); });
  topLinePts.push(topLinePts[0].clone());
  group.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(topLinePts), new THREE.LineBasicMaterial({ color: 0x6b5a48 })));

  var grommetR = 38.1;
  grommets.forEach(function(g) {
    var cPts = [];
    for (var i = 0; i <= 32; i++) {
      var a = (i/32) * Math.PI * 2;
      cPts.push(new THREE.Vector3(g.x + grommetR*Math.cos(a), H + 0.5, g.z + grommetR*Math.sin(a)));
    }
    group.add(new THREE.Line(new THREE.BufferGeometry().setFromPoints(cPts), new THREE.LineBasicMaterial({ color: 0x333333 })));
  });
  return group;
}

function buildDeskShelf(isBlack) {
  var group = new THREE.Group();
  var INCH = 25.4;
  var shelfL = 42*INCH, shelfW = 10*INCH, shelfH = 19;
  var legH = 5*INCH, legSpacing = 23.25*INCH;
  var stripThick = 7, stripWidth = 30, cornerR = 10;
  var legColor = isBlack ? 0x2a2a2a : 0xe5e5e5;
  var legEdgeColor = isBlack ? 0x444444 : 0x999999;

  // Shelf top (simple box)
  var shelfGeo = new THREE.BoxGeometry(shelfL, shelfH, shelfW);
  group.add(new THREE.Mesh(shelfGeo, new THREE.MeshBasicMaterial({ color: 0xc9a87a, side: THREE.DoubleSide })));
  group.add(new THREE.LineSegments(new THREE.EdgesGeometry(shelfGeo), new THREE.LineBasicMaterial({ color: 0x8a7560 })));

  function buildLeg() {
    var lg = new THREE.Group();
    var loopW = shelfW * 0.7, loopH = legH, r = cornerR, t = stripThick;
    var hw = loopW/2, hh = loopH/2;

    var outer = new THREE.Shape();
    outer.moveTo(-hw + r, -hh);
    outer.lineTo(hw - r, -hh);
    outer.quadraticCurveTo(hw, -hh, hw, -hh + r);
    outer.lineTo(hw, hh);
    outer.lineTo(-hw, hh);
    outer.lineTo(-hw, -hh + r);
    outer.quadraticCurveTo(-hw, -hh, -hw + r, -hh);

    var inner = new THREE.Path();
    var ihw = hw - t, ir = Math.max(r - t, 2);
    inner.moveTo(-ihw + ir, -hh + t);
    inner.lineTo(ihw - ir, -hh + t);
    inner.quadraticCurveTo(ihw, -hh + t, ihw, -hh + t + ir);
    inner.lineTo(ihw, hh);
    inner.lineTo(-ihw, hh);
    inner.lineTo(-ihw, -hh + t + ir);
    inner.quadraticCurveTo(-ihw, -hh + t, -ihw + ir, -hh + t);
    outer.holes.push(inner);

    var legGeo = new THREE.ExtrudeGeometry(outer, { depth: stripWidth, bevelEnabled: false });
    legGeo.rotateY(Math.PI / 2);
    legGeo.translate(-stripWidth/2, 0, 0);
    lg.add(new THREE.Mesh(legGeo, new THREE.MeshBasicMaterial({ color: legColor, side: THREE.DoubleSide })));
    lg.add(new THREE.LineSegments(new THREE.EdgesGeometry(legGeo, 20), new THREE.LineBasicMaterial({ color: legEdgeColor })));
    return lg;
  }

  var ll = buildLeg(); ll.position.set(-legSpacing/2, -legH/2, 0); group.add(ll);
  var rl = buildLeg(); rl.position.set(legSpacing/2, -legH/2, 0); group.add(rl);
  return group;
}

function buildCableTray() {
  var group = new THREE.Group();
  var INCH = 25.4;
  var trayL = 24.1*INCH, trayD = 3.9*INCH, trayH = 4.3*INCH, thick = 1.5;
  var trayColor = 0x333333, edgeColor = 0x555555;
  var sideGeo = new THREE.BoxGeometry(trayL, trayH, thick);
  var sideMat = new THREE.MeshBasicMaterial({ color: trayColor, side: THREE.DoubleSide });
  var eMat = new THREE.LineBasicMaterial({ color: edgeColor });

  function addPanel(geo, mat, x, y, z) {
    var g = new THREE.Group();
    g.add(new THREE.LineSegments(new THREE.EdgesGeometry(geo), eMat.clone()));
    g.add(new THREE.Mesh(geo.clone(), mat.clone()));
    g.position.set(x, y, z);
    group.add(g);
  }
  addPanel(sideGeo, sideMat, 0, -trayH/2, -trayD/2 + thick/2);
  addPanel(sideGeo, sideMat, 0, -trayH/2, trayD/2 - thick/2);
  addPanel(new THREE.BoxGeometry(trayL, thick, trayD), sideMat, 0, -trayH + thick/2, 0);
  return group;
}

function buildDesk(config) {
  var desk = new THREE.Group();
  var isBlack = config.legColor === 'black';
  var legInset = 130;
  var legSpanX = config.lengthMM - 2 * legInset;
  var footLength = config.widthMM >= 710 ? 710 : 560;
  var colHeight = 785;
  var footBaseY = 10, footTopY = footBaseY + 21;

  var lf = buildFootBar(footLength, true, isBlack);
  lf.position.set(-legSpanX/2, footBaseY + 21/2, 0); lf.rotation.y = Math.PI/2; desk.add(lf);
  var lc = buildColumn(colHeight, isBlack, 1);
  lc.position.set(-legSpanX/2, footTopY, 0); desk.add(lc);

  var rf = buildFootBar(footLength, false, isBlack);
  rf.position.set(legSpanX/2, footBaseY + 21/2, 0); rf.rotation.y = Math.PI/2; desk.add(rf);
  var rc = buildColumn(colHeight, isBlack, -1);
  rc.position.set(legSpanX/2, footTopY, 0); desk.add(rc);

  var tabletopY = footTopY + colHeight;
  var tt = buildTabletop(config.lengthMM, config.widthMM, config.grommets3D || []);
  tt.position.set(0, tabletopY, 0);
  desk.add(tt);

  if (config.addDeskShelf) {
    var shelf = buildDeskShelf(isBlack);
    var INCH = 25.4;
    shelf.position.set(0, tabletopY + 25 + 5*INCH, -(config.widthMM/2 - 10*INCH/2 - 20));
    desk.add(shelf);
  }
  if (config.addCableTray) {
    var tray = buildCableTray();
    var INCH = 25.4;
    tray.position.set(0, tabletopY, -(config.widthMM/2 - 3.9*INCH/2 - 10));
    desk.add(tray);
  }

  desk.scale.setScalar(SCALE);
  return desk;
}

// ============================================================================
// 3D VIEWER ENGINE
// ============================================================================
function createViewer(container) {
  var scene = new THREE.Scene();
  scene.background = new THREE.Color(0xf5f5f5);
  var w = container.clientWidth || 800;
  var h = container.clientHeight || 600;
  var camera = new THREE.PerspectiveCamera(30, w/h, 0.1, 500);
  var renderer = new THREE.WebGLRenderer({ antialias: true });
  renderer.setSize(w, h);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  container.appendChild(renderer.domElement);

  var grid = new THREE.GridHelper(30, 30, 0xe8e8e8, 0xf2f2f2);
  scene.add(grid);

  var deskObj = null;
  var rot = { x: 0.4, y: -0.7 }, tRot = { x: 0.4, y: -0.7 };
  var zoom = 1, tZoom = 1;
  var dragging = false, lastM = { x: 0, y: 0 };

  function updateDesk(config) {
    if (deskObj) {
      scene.remove(deskObj);
      deskObj.traverse(function(o) { if (o.geometry) o.geometry.dispose(); if (o.material) o.material.dispose && o.material.dispose(); });
    }
    deskObj = buildDesk(config);
    scene.add(deskObj);
  }

  function animate() {
    requestAnimationFrame(animate);
    rot.x += (tRot.x - rot.x) * 0.08;
    rot.y += (tRot.y - rot.y) * 0.08;
    zoom += (tZoom - zoom) * 0.08;
    var dist = 35 * zoom;
    camera.position.set(dist * Math.cos(rot.x) * Math.sin(rot.y), dist * Math.sin(rot.x) + 4, dist * Math.cos(rot.x) * Math.cos(rot.y));
    camera.lookAt(0, 4, 0);
    camera.aspect = (container.clientWidth || 800) / (container.clientHeight || 600);
    camera.updateProjectionMatrix();
    if (container.clientWidth > 0 && container.clientHeight > 0) {
      renderer.setSize(container.clientWidth, container.clientHeight);
    }
    renderer.render(scene, camera);
  }
  animate();

  container.addEventListener('mousedown', function(e) { dragging = true; lastM = { x: e.clientX, y: e.clientY }; });
  container.addEventListener('mousemove', function(e) {
    if (!dragging) return;
    tRot.y -= (e.clientX - lastM.x) * 0.005;
    tRot.x = Math.max(0.05, Math.min(1.4, tRot.x + (e.clientY - lastM.y) * 0.005));
    lastM = { x: e.clientX, y: e.clientY };
  });
  container.addEventListener('mouseup', function() { dragging = false; });
  container.addEventListener('mouseleave', function() { dragging = false; });
  container.addEventListener('wheel', function(e) { tZoom = Math.max(0.4, Math.min(2.5, tZoom + e.deltaY * 0.001)); });
  container.addEventListener('touchstart', function(e) { if (e.touches.length === 1) { dragging = true; lastM = { x: e.touches[0].clientX, y: e.touches[0].clientY }; } }, { passive: true });
  container.addEventListener('touchmove', function(e) {
    if (!dragging || e.touches.length !== 1) return;
    tRot.y -= (e.touches[0].clientX - lastM.x) * 0.005;
    tRot.x = Math.max(0.05, Math.min(1.4, tRot.x + (e.touches[0].clientY - lastM.y) * 0.005));
    lastM = { x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });
  container.addEventListener('touchend', function() { dragging = false; }, { passive: true });

  return { updateDesk: updateDesk };
}

// ============================================================================
// UI (vanilla DOM)
// ============================================================================
function createConfigurator() {
  var state = {
    length: 60, width: 30, legColor: 'black',
    grommets: [], addCableTray: false, addDeskShelf: false
  };
  var viewer = null;
  var overlay = null;

  function getConfig() {
    var grommets3D = state.grommets.map(function(g) {
      return { x: state.length * INCH_TO_MM / 2 - g.fromRight * INCH_TO_MM, z: -(state.width * INCH_TO_MM / 2 - g.fromRear * INCH_TO_MM) };
    });
    return {
      lengthMM: state.length * INCH_TO_MM,
      widthMM: state.width * INCH_TO_MM,
      legColor: state.legColor,
      grommets3D: grommets3D,
      addCableTray: state.addCableTray,
      addDeskShelf: state.addDeskShelf,
    };
  }

  function refresh() {
    if (viewer) viewer.updateDesk(getConfig());
    updatePriceDisplay();
  }

  var priceEls = [];
  function updatePriceDisplay() {
    var p = calcPrice(state.length, state.width, state.grommets.length, state.addCableTray, state.addDeskShelf);
    priceEls.forEach(function(el) {
      el.innerHTML = '<span style="font-size:22px;font-weight:700;color:#1a1a1a">₹' + formatINR(p.sale) + '</span>' +
        '<span style="font-size:13px;color:#999;text-decoration:line-through;margin-left:8px">₹' + formatINR(p.regular) + '</span>';
    });
  }

  function makeSlider(label, value, min, max, onChange) {
    var wrap = document.createElement('div');
    wrap.style.cssText = 'margin-bottom:20px;';
    var lbl = document.createElement('div');
    lbl.style.cssText = 'font-size:13px;color:#555;font-weight:500;margin-bottom:8px;';
    lbl.textContent = label;
    wrap.appendChild(lbl);

    var track = document.createElement('div');
    track.style.cssText = 'position:relative;height:36px;display:flex;align-items:center;';
    var bg = document.createElement('div');
    bg.style.cssText = 'position:absolute;left:0;right:0;height:3px;background:#e0e0e0;border-radius:2px;top:50%;transform:translateY(-50%);';
    var fill = document.createElement('div');
    fill.style.cssText = 'height:100%;background:#1a1a1a;border-radius:2px;';
    bg.appendChild(fill);
    track.appendChild(bg);

    var input = document.createElement('input');
    input.type = 'range'; input.min = min; input.max = max; input.step = 1; input.value = value;
    input.style.cssText = 'position:absolute;left:0;right:0;width:100%;opacity:0;cursor:pointer;z-index:2;height:36px;';
    track.appendChild(input);

    var badge = document.createElement('div');
    badge.style.cssText = 'position:absolute;background:#1a1a1a;color:#fff;padding:3px 10px;border-radius:16px;font-size:12px;font-weight:600;pointer-events:none;white-space:nowrap;transform:translateX(-50%);';
    track.appendChild(badge);

    function update(v) {
      var pct = ((v - min) / (max - min)) * 100;
      fill.style.width = pct + '%';
      badge.style.left = pct + '%';
      badge.textContent = v + '"';
    }
    update(value);
    input.addEventListener('input', function() { var v = parseInt(this.value); update(v); onChange(v); });

    wrap.appendChild(track);
    return wrap;
  }

  var panelContainer = null;
  var viewerDiv = null;

  function open(initLength, initWidth, initColor) {
    state.length = initLength || 60;
    state.width = initWidth || 30;
    state.legColor = initColor || 'black';
    state.grommets = [];
    state.addCableTray = false;
    state.addDeskShelf = false;

    if (overlay) { overlay.remove(); overlay = null; viewer = null; }

    overlay = document.createElement('div');
    overlay.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;z-index:99999;background:#fff;font-family:inherit;display:flex;flex-direction:column;';

    // Close button
    var closeBtn = document.createElement('button');
    closeBtn.innerHTML = '×';
    closeBtn.style.cssText = 'position:absolute;top:12px;right:12px;z-index:10;width:40px;height:40px;border-radius:50%;border:1px solid #e0e0e0;background:#fff;cursor:pointer;font-size:20px;color:#666;box-shadow:0 2px 8px rgba(0,0,0,0.1);display:flex;align-items:center;justify-content:center;';
    closeBtn.addEventListener('click', function() { overlay.remove(); overlay = null; viewer = null; });
    overlay.appendChild(closeBtn);

    // Layout
    var layout = document.createElement('div');
    layout.style.cssText = 'display:flex;flex:1;overflow:hidden;';
    layout.className = 'dcfg-layout';
    overlay.appendChild(layout);

    // 3D viewer (created once)
    viewerDiv = document.createElement('div');
    viewerDiv.style.cssText = 'flex:1;position:relative;background:#f5f5f5;min-height:300px;cursor:grab;touch-action:none;';
    viewerDiv.className = 'dcfg-viewer';
    layout.appendChild(viewerDiv);

    // Panel container (rebuilt on each render)
    panelContainer = document.createElement('div');
    panelContainer.style.cssText = 'width:380px;overflow-y:auto;display:flex;flex-direction:column;border-left:1px solid #eee;';
    panelContainer.className = 'dcfg-panel';
    layout.appendChild(panelContainer);

    // Mobile CSS
    var style = document.createElement('style');
    style.textContent = '@media(max-width:768px){.dcfg-layout{flex-direction:column !important;}.dcfg-viewer{flex:none !important;height:40vh !important;max-height:350px !important;}.dcfg-panel{width:100% !important;border-left:none !important;border-top:1px solid #eee !important;}}';
    overlay.appendChild(style);

    document.body.appendChild(overlay);

    // Init 3D viewer once
    setTimeout(function() {
      try {
        viewer = createViewer(viewerDiv);
        renderPanel();
      } catch(e) {
        console.error('Desk Configurator 3D error:', e);
      }
    }, 200);
  }

  function renderPanel() {
    panelContainer.innerHTML = '';
    var panel = document.createElement('div');
    panel.style.cssText = 'padding:20px 24px;display:flex;flex-direction:column;flex:1;';

    // Title
    var title = document.createElement('h2');
    title.textContent = 'Custom Model 304 Desk';
    title.style.cssText = 'font-size:20px;font-weight:700;margin:0 0 2px 0;color:#1a1a1a;';
    panel.appendChild(title);
    var sub = document.createElement('p');
    sub.textContent = 'Configure your perfect workspace';
    sub.style.cssText = 'font-size:12px;color:#999;margin:0 0 16px 0;';
    panel.appendChild(sub);

    // Step 1: Dimensions
    var s1 = document.createElement('div');
    s1.style.cssText = 'border-bottom:1px solid #eee;padding-bottom:16px;margin-bottom:8px;';
    var s1h = document.createElement('div');
    s1h.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 0;';
    s1h.innerHTML = '<span style="width:26px;height:26px;border-radius:50%;background:#1a1a1a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700">1</span><span style="font-size:15px;font-weight:600;color:#1a1a1a">Desk dimensions</span>';
    s1.appendChild(s1h);
    s1.appendChild(makeSlider('Length', state.length, 48, 78, function(v) { state.length = v; refresh(); }));
    s1.appendChild(makeSlider('Width', state.width, 24, 38, function(v) { state.width = v; refresh(); }));
    panel.appendChild(s1);

    // Step 2: Frame color
    var s2 = document.createElement('div');
    s2.style.cssText = 'border-bottom:1px solid #eee;padding-bottom:16px;margin-bottom:8px;';
    s2.innerHTML = '<div style="display:flex;align-items:center;gap:10px;padding:10px 0;"><span style="width:26px;height:26px;border-radius:50%;background:#1a1a1a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700">2</span><span style="font-size:15px;font-weight:600;color:#1a1a1a">Frame color</span></div>';
    var colorWrap = document.createElement('div');
    colorWrap.style.cssText = 'display:flex;gap:8px;padding-left:36px;';
    ['black', 'white'].forEach(function(c) {
      var btn = document.createElement('button');
      btn.style.cssText = 'display:flex;align-items:center;gap:8px;padding:8px 18px;border:2px solid ' + (c === state.legColor ? '#1a1a1a' : '#e0e0e0') + ';border-radius:24px;background:' + (c === state.legColor ? '#f5f5f5' : '#fff') + ';cursor:pointer;font-size:13px;font-weight:' + (c === state.legColor ? '600' : '400') + ';color:#1a1a1a;text-transform:capitalize;font-family:inherit;';
      btn.innerHTML = '<span style="width:16px;height:16px;border-radius:50%;background:' + (c === 'black' ? '#333' : '#eee') + ';border:2px solid ' + (c === 'black' ? '#222' : '#ccc') + ';display:inline-block"></span>' + c;
      btn.addEventListener('click', function() { state.legColor = c; renderPanel(); });
      colorWrap.appendChild(btn);
    });
    s2.appendChild(colorWrap);
    panel.appendChild(s2);

    // Step 3: Grommets
    var s3 = document.createElement('div');
    s3.style.cssText = 'border-bottom:1px solid #eee;padding-bottom:16px;margin-bottom:8px;';
    s3.innerHTML = '<div style="display:flex;align-items:center;gap:10px;padding:10px 0;"><span style="width:26px;height:26px;border-radius:50%;background:#1a1a1a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700">3</span><span style="font-size:15px;font-weight:600;color:#1a1a1a">Cable grommets</span></div><p style="font-size:11px;color:#999;margin:0 0 10px 0;padding-left:36px;">3" circular cable holes (max 3)</p>';
    
    // Render existing grommets
    var gromWrap = document.createElement('div');
    gromWrap.style.cssText = 'padding-left:36px;';
    state.grommets.forEach(function(g, idx) {
      var card = document.createElement('div');
      card.style.cssText = 'background:#f7f7f7;border-radius:10px;padding:14px;margin-bottom:10px;';
      var header = document.createElement('div');
      header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;';
      var label = document.createElement('span');
      label.style.cssText = 'font-size:13px;font-weight:600;';
      label.textContent = 'Grommet ' + (idx + 1);
      var removeBtn = document.createElement('button');
      removeBtn.textContent = 'Remove';
      removeBtn.style.cssText = 'background:none;border:1px solid #ddd;border-radius:6px;padding:3px 10px;cursor:pointer;font-size:11px;color:#888;font-family:inherit;';
      removeBtn.addEventListener('click', function() { state.grommets.splice(idx, 1); renderPanel(); });
      header.appendChild(label);
      header.appendChild(removeBtn);
      card.appendChild(header);
      card.appendChild(makeSlider('From right edge', g.fromRight, 5, Math.floor(state.length - 5), function(v) { state.grommets[idx].fromRight = v; refresh(); }));
      card.appendChild(makeSlider('From rear edge', g.fromRear, 4, Math.floor(state.width - 4), function(v) { state.grommets[idx].fromRear = v; refresh(); }));
      gromWrap.appendChild(card);
    });
    s3.appendChild(gromWrap);

    if (state.grommets.length < 3) {
      var addGromBtn = document.createElement('button');
      addGromBtn.textContent = '+ Add grommet';
      addGromBtn.style.cssText = 'width:calc(100% - 36px);margin-left:36px;padding:10px;border:2px dashed #ddd;border-radius:8px;background:none;cursor:pointer;font-size:12px;color:#888;font-family:inherit;';
      addGromBtn.addEventListener('click', function() {
        state.grommets.push({ fromRight: Math.round(state.length / 2), fromRear: 4 });
        renderPanel();
      });
      s3.appendChild(addGromBtn);
    }
    panel.appendChild(s3);

    // Step 4: Add-ons
    var s4 = document.createElement('div');
    s4.style.cssText = 'border-bottom:1px solid #eee;padding-bottom:16px;margin-bottom:8px;';
    s4.innerHTML = '<div style="display:flex;align-items:center;gap:10px;padding:10px 0;"><span style="width:26px;height:26px;border-radius:50%;background:#1a1a1a;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700">4</span><span style="font-size:15px;font-weight:600;color:#1a1a1a">Add-ons</span></div>';
    var addonsWrap = document.createElement('div');
    addonsWrap.style.cssText = 'display:flex;flex-direction:column;gap:8px;padding-left:36px;';

    [{ key: 'addCableTray', label: 'Cable Organizer Tray', desc: 'Under-desk cable management', price: PRICE_CABLE },
     { key: 'addDeskShelf', label: 'Monitor Desk Shelf', desc: 'Elevated shelf for monitor', price: PRICE_SHELF }
    ].forEach(function(item) {
      var lbl = document.createElement('label');
      lbl.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 14px;border:2px solid ' + (state[item.key] ? '#1a1a1a' : '#e8e8e8') + ';border-radius:8px;cursor:pointer;transition:all 0.15s;font-family:inherit;';
      var cb = document.createElement('input');
      cb.type = 'checkbox'; cb.checked = state[item.key];
      cb.style.cssText = 'width:16px;height:16px;accent-color:#1a1a1a;';
      cb.addEventListener('change', function() { state[item.key] = this.checked; refresh(); lbl.style.borderColor = this.checked ? '#1a1a1a' : '#e8e8e8'; });
      lbl.appendChild(cb);
      var info = document.createElement('div');
      info.style.flex = '1';
      info.innerHTML = '<div style="font-size:13px;font-weight:500">' + item.label + '</div><div style="font-size:11px;color:#999">' + item.desc + '</div>';
      lbl.appendChild(info);
      var pr = document.createElement('span');
      pr.style.cssText = 'font-size:12px;font-weight:600;';
      pr.textContent = '+₹' + formatINR(item.price);
      lbl.appendChild(pr);
      addonsWrap.appendChild(lbl);
    });
    s4.appendChild(addonsWrap);
    panel.appendChild(s4);

    // Price + Cart
    var priceBar = document.createElement('div');
    priceBar.style.cssText = 'margin-top:auto;padding-top:16px;border-top:1px solid #eee;';
    var priceDisplay = document.createElement('div');
    priceDisplay.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;margin-bottom:12px;';
    var pLabel = document.createElement('span');
    pLabel.textContent = 'Total';
    pLabel.style.cssText = 'font-size:13px;color:#999;';
    var pValue = document.createElement('span');
    priceEls = [pValue];
    priceDisplay.appendChild(pLabel);
    priceDisplay.appendChild(pValue);
    priceBar.appendChild(priceDisplay);

    var cartBtn = document.createElement('button');
    cartBtn.innerHTML = 'Proceed to Checkout &rarr;';
    cartBtn.style.cssText = 'width:100%;padding:14px;background:#1a1a1a;color:#fff;border:none;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;';
    cartBtn.addEventListener('click', function() { proceedToCheckout(state, panelContainer, overlay); });
    cartBtn.addEventListener('mouseenter', function() { this.style.background = '#333'; });
    cartBtn.addEventListener('mouseleave', function() { this.style.background = '#1a1a1a'; });
    priceBar.appendChild(cartBtn);
    panel.appendChild(priceBar);

    panelContainer.appendChild(panel);
    refresh();
  }

  // Listen for open events
  window.addEventListener('open-desk-configurator', function(e) {
    var d = e.detail || {};
    open(d.length || 60, d.width || 30, d.color || 'black');
  });

  // Auto-bind buttons
  document.querySelectorAll('.open-desk-configurator').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var handle = this.dataset.handle || '';
      var length = 55, width = 28, color = 'black';
      if (handle.indexOf('60x30') !== -1) { length = 60; width = 30; }
      if (handle.indexOf('white') !== -1) { color = 'white'; }
      window.dispatchEvent(new CustomEvent('open-desk-configurator', {
        detail: { length: length, width: width, color: color }
      }));
    });
  });
}

// Auto-init when DOM ready
function initWhenReady() {
  if (typeof THREE === 'undefined') {
    console.error('Desk Configurator: Three.js not loaded. Make sure three.min.js is included before desk-configurator.js');
    return;
  }
  createConfigurator();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWhenReady);
} else {
  initWhenReady();
}

})();